import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
const voiceOptions = ["Puck", "Charon", "Kore", "Fenrir", "Aoede"] as const;
function Settings() {
const navigate = useNavigate();
const [systemPrompt, setSystemPrompt] = useState("");
const [voiceName, setVoiceName] = useState("aoede");
const [opts, setOpts] = useState({
text: "",
user: "",
gender: "",
profession: "",
age: "",
tone: "",
googleSearch: false,
});
useEffect(() => {
document.title = "Settings | LensTalk";
setSystemPrompt(
localStorage.getItem("systemPrompt") ||
"You are my helpful assistant. Don’t ask for additional information; just make your best judgment."
);
const savedOpts = JSON.parse(localStorage.getItem("opts") || "{}");
setOpts({
...opts,
...savedOpts,
});
setVoiceName(localStorage.getItem("voicename") || "aoede");
}, []);
const handleChange = (key: keyof typeof opts, value: any) => {
setOpts((prev) => ({ ...prev, [key]: value }));
};
const saveSettings = (event: React.FormEvent) => {
event.preventDefault();
let prompt = opts.text || "";
if (opts.user) prompt += ` Here is my details: ${opts.user}.`;
if (opts.googleSearch) prompt += " Use Google search while answering (if required).";
if (opts.profession) prompt += ` I am a ${opts.profession}.`;
if (opts.age) prompt += ` I am ${opts.age} years old.`;
if (opts.tone) prompt += ` Please respond in a ${opts.tone} tone.`;
if (opts.gender) prompt += ` I identify as ${opts.gender}.`;
localStorage.setItem("systemPrompt", prompt);
localStorage.setItem("opts", JSON.stringify(opts));
localStorage.setItem("voicename", voiceName);
navigate("/");
};
return (
<>
<h1>Settings</h1>
<p>
Enhance the AI's communication by adjusting its modalities to deliver responses that align with your expectations.
</p>
<form onSubmit={saveSettings}>
<Textarea
label="Base Instruction"
id="systemPrompt"
description="Personalize the AI's output by adjusting the base instructions."
value={opts.text}
onChange={(value: any) => handleChange("text", value)}
/>

<Textarea
label="Your Details"
id="persona"
description="Provide your details to enable the AI to identify you and offer responses specific to your needs."
value={opts.user}
onChange={(value: any) => handleChange("user", value)}
/>

<label htmlFor="voice-select">Voice:</label>
<select
id="voice-select"
value={voiceName}
onChange={(e) => {
const value = e.target.value;
setVoiceName(value);
localStorage.setItem("voicename", value);
}}
>
{voiceOptions.map((voice) => (
<option key={voice} value={voice}>
{voice}
</option>
))}
</select>

<RadioGroup
label="Your Gender"
options={[
{ label: "Male", value: "male" },
{ label: "Female", value: "female" },
]}
selectedValue={opts.gender}
onChange={(value: any) => handleChange("gender", value)}
/>

<RadioGroup
label="Your Profession"
options={[
{ label: "Student", value: "student" },
{ label: "Working Professional", value: "working professional" },
{ label: "Business Person", value: "business person" },
{ label: "Unemployed", value: "unemployed" },
{ label: "Home Maker", value: "home maker" },
{ label: "Govt Employee", value: "govt employee" },
]}
selectedValue={opts.profession}
onChange={(value: any) => handleChange("profession", value)}
/>

<label>Age:</label>
<input
type="number"
value={opts.age}
onChange={(e) => handleChange("age", e.target.value)}
min="0"
/>

<RadioGroup
label="Preferred Tone"
options={[
{ label: "Friendly", value: "friendly" },
{ label: "Joking", value: "joking" },
{ label: "Professional", value: "professional" },
{ label: "Serious", value: "serious" },
{ label: "Creative", value: "creative" },
{ label: "Regular", value: "regular" },
]}
selectedValue={opts.tone}
onChange={(value: any) => handleChange("tone", value)}
/>

<Checkbox
label="Use Google Search?"
checked={opts.googleSearch}
onChange={(value: any) => handleChange("googleSearch", value)}
/>

<button type="submit">Save Settings</button>
</form>
</>
);
}

export default Settings;

// Helper Components
function Textarea({ label, id, description, value, onChange }: any) {
return (
<>
<label htmlFor={id}>{label}</label>
<p>{description}</p>
<textarea
id={id}
rows={5}
cols={50}
value={value}
onChange={(e) => onChange(e.target.value)}
></textarea>
</>
);
}

function RadioGroup({ label, options, selectedValue, onChange }: any) {
return (
<>
<label>{label}</label>
{options.map((option: any) => (
<label key={option.value}>
<input
type="radio"
value={option.value}
checked={selectedValue === option.value}
onChange={() => onChange(option.value)}
/>
{option.label}
</label>
))}
</>
);
}

function Checkbox({ label, checked, onChange }: any) {
return (
<>
<label>
<input
type="checkbox"
checked={checked}
onChange={(e) => onChange(e.target.checked)}
/>{" "}
{label}
</label>
</>
);
}
